// extracted by mini-css-extract-plugin
module.exports = {"tag":"cf_m9","tag_negative":"cf_nb"};